import React from "react";

// Translucent band under the system status bar (iOS/Android edge-to-edge). Content
// that scrolls past the top is blurred beneath it instead of colliding with the
// clock/battery. Height = --sa-top → 0 on desktop/web (invisible).
export const StatusBarShim = () => (
  <div
    aria-hidden
    className="fixed top-0 left-0 right-0 z-[45] pointer-events-none yalola-glass !border-b-0"
    style={{ height: "var(--sa-top)" }}
    data-testid="status-bar-shim"
    data-native-occluder="status-bar"
  />
);

export default StatusBarShim;
